import api from './api';

export const getProjects = (params) => api.get('/projects', { params });
export const createProject = (data) => api.post('/projects', data);
export const getProject = (projectId) => api.get(`/projects/${projectId}`);
export const updateProject = (projectId, data) => api.patch(`/projects/${projectId}`, data);
export const linkSpace = (projectId, spaceId) => api.post(`/projects/${projectId}/spaces`, { spaceId });
export const unlinkSpace = (projectId, spaceId) => api.delete(`/projects/${projectId}/spaces/${spaceId}`);
export const addProjectMember = (projectId, userId, role) => api.post(`/projects/${projectId}/members`, { userId, role });
export const removeProjectMember = (projectId, userId) => api.delete(`/projects/${projectId}/members/${userId}`);
export const addProjectGroup = (projectId, groupId) => api.post(`/projects/${projectId}/groups`, { groupId });
export const removeProjectGroup = (projectId, groupId) => api.delete(`/projects/${projectId}/groups/${groupId}`);
export const getProjectReportSummary = (projectId) => api.get(`/projects/${projectId}/report-summary`);
export const getProjectTasks = (projectId) => api.get(`/projects/${projectId}/tasks`);
export const getProjectMileage = (projectId) => api.get(`/projects/${projectId}/mileage`);
export const getProjectTime = (projectId) => api.get(`/projects/${projectId}/time`);
